var lottie = { exports: {} };
export {
  lottie as __module
};
//# sourceMappingURL=lottie.js.map
